import axios from "axios";

import {
  reducerTemplateUnloadingsFilters,
  reducerTemplateUnloadings,
  reducerTemplateSingleUnloadings
} from "../../reducer/unloadings/reducers/templateUnloadings";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetTemplateUnloadings =
  (limit: number, page: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;

      const store = getState();
      const filter = store.unloadings.templateUnloadings.templateUnloadingsInputValues;
      try {
        const response = await axios.post(`${BASE_URL}/json/orders/imports`, {
          limit,
          page,
          ...filter,
        });
        dispatch(reducerTemplateUnloadings({ data: response.data, limit, page: 1 }));
      } catch {
        console.log('err');
      };
    };

export const actionGetTemplateUnloadingsFilters =
  () => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.get(`${BASE_URL}/json/orders/excel/filters`);
    try {
      dispatch(reducerTemplateUnloadingsFilters({ data: response.data }));
    } catch {
      console.log('err');
    };
  };


export const actionGetTemplateUnloadingsRetry =
  (id: { id: number }) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      try {
        const response = await axios.post(`${BASE_URL}/json/orders/excel/retry`, id);
        dispatch(reducerTemplateSingleUnloadings(response.data));
      } catch {
        console.log('err');
      };
    };
